export default [
  {
    path: '/rights/index',
    name: 'PageRightsIndex',
    component: () =>
      import(
        /* webpackChunkName: "rights" */ '../pages/rights/PageRightsIndex'
      ),
    meta: { modular: 301, title: '权益中心', info: '权益中心——首页' }
  }
]
